import React, { useState, useEffect, useContext } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import { LanguageContext } from '../LanguageContext'; // For i18n
import axios from 'axios'; // If using the backend at all
import './ResourcePage.css'; // For styling
import NavBar from '../components/NavBar'; // For top
import BottomBar from '../components/BottomBar'; // For bottom
import SubscriptionForm from '../components/SubscriptionForm'; // For subscription form

// This relies on the frontend .env file
// Note that const cannot be above import statements
const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

function ResourcePage() {
    const { t, setLanguage } = useContext(LanguageContext);
    // const variables
    // useEffect 
    return (
        <>
            <NavBar />
            <div className="text-section">
                <ol>
                    <li><Link to="/resource1">Resource 1</Link></li>
                    <br />
                    <li><Link to="/">Second line of text</Link></li>
                    <br />
                    <li><Link to="/">Third line of text</Link></li>
                    <br />
                </ol>
            </div>
            <SubscriptionForm />
        </>
    );
};

export default ResourcePage;